var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-layout",
    { attrs: { "is-logged-in": _vm.isLoggedIn, "login-url": _vm.loginUrl } },
    [
      _c("section", { staticClass: "welcome-main" }, [
        _c("div", { staticClass: "columns is-gapless is-relative" }, [
          _c("div", { staticClass: "column is-half welcome-column-top" }, [
            _c("div", {
              staticClass: "bg-image--cover bg-image--center bg-image-welcome",
              style: { backgroundImage: "url(" + _vm.backgroundImage + ")" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column is-half" }, [
            _c("section", { staticClass: "hero is-fullheight welcome-hero" }, [
              _c("div", { staticClass: "hero-body p-0" }, [
                _c("div", { staticClass: "container welcome__message" }, [
                  _vm.logo
                    ? _c("img", {
                        staticClass: "welcome__logo mbr-4",
                        attrs: { src: _vm.logo }
                      })
                    : _vm.brandName && _vm.name && _vm.brandName !== _vm.name
                    ? _c(
                        "h3",
                        { staticClass: "title is-size-3 is-uppercase mbr-4" },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.name) +
                              " by " +
                              _vm._s(_vm.brandName) +
                              "\n                            "
                          )
                        ]
                      )
                    : _vm.brandName
                    ? _c(
                        "h3",
                        { staticClass: "title is-size-3 is-uppercase mbr-4" },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.brandName) +
                              "\n                            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.headline
                    ? _c("h1", { staticClass: "title welcome-brand-title" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.headline) +
                            "\n                            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.description
                    ? _c(
                        "div",
                        { staticClass: "pl-6 pr-6 mbr-4 welcome-description" },
                        [
                          _c("title-text", { attrs: { text: _vm.description } })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRecruitmentOn
                    ? _c(
                        "a",
                        {
                          staticClass: "button is-primary welcome-action-btn",
                          attrs: {
                            href: !_vm.isLoggedIn
                              ? _vm.loginUrl
                              : "/getStarted?handle=" + _vm.handle
                          }
                        },
                        [_vm._v("Get Started")]
                      )
                    : _c("p", [
                        _vm._v(
                          "\n                                This brand is not currently recruiting\n                            "
                        )
                      ]),
                  _vm._v(" "),
                  _vm.pointOfContact
                    ? _c(
                        "div",
                        { attrs: { "data-test-point-of-contact": "" } },
                        [
                          _vm.pointOfContact.name
                            ? _c("p", [
                                _vm._v(
                                  "\n                                    For more information, contact"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.pointOfContact.name) +
                                    " at\n                                    "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:" + _vm.pointOfContact.email
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.pointOfContact.email) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                            : _c("p", [
                                _vm._v(
                                  "\n                                    For more information, contact\n                                    "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:" + _vm.pointOfContact.email
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.pointOfContact.email) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isLoggedIn
                    ? _c("p", { staticClass: "is-hidden-tablet pt-4" }, [
                        _vm._v(
                          "\n                                Already have an account? "
                        ),
                        _c("a", { attrs: { href: _vm.loginUrl } }, [
                          _vm._v("Log in.")
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }